var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoCustomerCenter = function SvgMoCustomerCenter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 52,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mo-customerCenter_svg__a)",
    d: "M89.529 2.64c-4.916-6.295-15.537-.948-23.72 11.955a59 59 0 0 0-4.13 7.75c2.324-8.243 2.202-15.777-.864-19.705-4.915-6.295-15.537-.948-23.719 11.955a59 59 0 0 0-4.13 7.75c2.323-8.243 2.202-15.777-.864-19.705-4.916-6.295-15.537-.948-23.72 11.955C.202 27.5-2.443 43.06 2.473 49.36c4.915 6.295 15.536.948 23.718-11.955a59 59 0 0 0 4.13-7.75c-2.323 8.243-2.201 15.776.865 19.705 4.915 6.295 15.537.948 23.719-11.955a59 59 0 0 0 4.13-7.75c-2.323 8.243-2.202 15.776.864 19.705 4.916 6.295 15.537.948 23.72-11.955C91.798 24.5 94.443 8.94 89.527 2.64"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "mo-customerCenter_svg__a",
    x1: 8.846,
    x2: 23.911,
    y1: 12.103,
    y2: 75.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004EFF"
  })))));
};
export default SvgMoCustomerCenter;